export default __webpack_public_path__ + "static/media/con_MOVG01.8472f748.jpg";